import Button from "../../components/Button"
import {ICatGridFilter, ICatGridQuery} from '../../helpers/Interfaces'

interface HomeProps {
    filterObj: ICatGridFilter;
    setFilterObj: Function;
    queryObj: ICatGridQuery;
    setQueryObj: Function;
}

export default function FieldsFilterBlock(props: HomeProps) {

    const {filterObj, setFilterObj, queryObj, setQueryObj} = props
    let capFieldType = filterObj.fieldType ? filterObj.fieldType.charAt(0).toUpperCase() + filterObj.fieldType.slice(1) : 'Field'

    function handleChange(value: string, name: string) {
        setFilterObj((prevState: any) => {
            return {...prevState, [name as keyof typeof prevState]: value.trimStart()}
        })
    }

    function handleClick(event: any) {
        window.history.replaceState(null, '', `../fields/1`)

        if (event.target.name === 'Search' || event.key === 'Enter') {
            setQueryObj((prevState: any) => {
                return {...prevState, filterObj: filterObj, currentPage: 1}
            })
            localStorage.setItem('filterFields', JSON.stringify(filterObj));

        } else {
            for (let k in filterObj) {
                if (k !== 'taxType') {    // if (k !== 'taxType' && k !== 'fieldType') {
                    filterObj[k as keyof typeof filterObj] = ''
                }
            }
            setQueryObj((prevState: any) => {
                return {...prevState, filterObj: filterObj, currentPage: 1}
            })

            localStorage.removeItem("filterFields")
            // localStorage.setItem('filterFields', JSON.stringify({}));
        }
    }

    return (

        <div className="filter-base-container fields-grid-filter">

            <div className="trg-subcont">
                <div className="field-label">Taxonomy type</div>
                <select
                    // id="tax_type"
                    name="taxType"
                    className="bold"
                    onChange={(event) => handleChange(event.target.value, event.target.name)}
                    // onKeyDown={(event) => event.key === 'Enter' ? handleClick(event) : ''}
                    value={filterObj.taxType}
                >
                    <option value="target">target</option>
                    <option value="source">source</option>
                </select>
            </div>


            <div className="trg-subcont">
                <div className="field-label">Field type</div>
                <select
                    // id="field_type"
                    name="fieldType"
                    className="bold"
                    onChange={(event) => handleChange(event.target.value, event.target.name)}
                    // onKeyDown={(event) => event.key === 'Enter' ? handleClick(event) : ''}
                    value={filterObj.fieldType}
                >
                    <option value=""></option>
                    <option value="category">category</option>
                    <option value="brand">brand</option>
                    <option value="family">family</option>
                    <option value="locale">locale</option>
                </select>
            </div>

            <div className="trg-subcont">
                <div className="field-label">{capFieldType} ID</div>
                <input
                    // id="cat-id"
                    name="fieldID"
                    type="text"
                    className="filter-input"
                    onChange={(event) => handleChange(event.target.value, event.target.name)}
                    onKeyDown={(event) => event.key === 'Enter' ? handleClick(event) : ''}
                    value={filterObj.fieldID}
                />
            </div>

            <div className="trg-subcont">
                <div className="field-label">{capFieldType} Name</div>
                <input
                    // id="cat-name"
                    name="fieldName"
                    type="text"
                    className="filter-input"
                    onChange={(event) => handleChange(event.target.value, event.target.name)}
                    onKeyDown={(event) => event.key === 'Enter' ? handleClick(event) : ''}
                    value={filterObj.fieldName}
                />
            </div>

            <div className="trg-subcont">
                <div className="field-label">Status</div>
                <select
                    // id="trg-map-status"
                    name="mapStatus"
                    value={filterObj.mapStatus}
                    // disabled={filterObj.tax_type === 'source'}
                    // className={filterObj.tax_type === 'source' ? 'readonly-input' : ''}
                    onChange={(event) => handleChange(event.target.value, event.target.name)}
                >
                    <option value=""></option>
                    <option value="mapped">mapped</option>
                    <option value="not mapped">not mapped</option>
                    <option value="parked">parked</option>
                </select>
            </div>

            <div className="trg-subcont">
                <div className="field-label">Comment ?</div>
                <select
                    // id="trg-map-remark"
                    name="mapRemark"
                    value={filterObj.mapRemark}
                    disabled={filterObj.taxType === 'source'}
                    className={filterObj.taxType === 'source' ? 'readonly-input' : ''}
                    onChange={(event) => handleChange(event.target.value, event.target.name)}
                >
                    <option value=""></option>
                    <option value="yes">yes</option>
                    <option value="no">no</option>
                </select>
            </div>

            <div className="btn-container">
                {/*<Button type="primary" text="Search" onclick={handleClick}/>*/}
                <Button type="primary" text="Search" onclick={(event: any) => handleClick(event)}/>
            </div>

            <div className="btn-container">
                <Button type="secondary" text="Clear" onclick={(event: any) => handleClick(event)}/>
            </div>

        </div>

    )
}
